import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import configPlugin from '@/plugins/config'
import axios from 'axios'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faHome,
  faUsers,
  faCog,
  faSignOutAlt,
  faUser,
  faPhone,
  faPhoneSlash,
  faKey,
  faFileAlt,
  faPlay,
  faPause,
  faStop,
  faQuestion,
  faHandPointer,
  faPhoneAlt,
  faLightbulb,
  faRedoAlt,
  faDollarSign,
  faInfoCircle,
  faUserCircle,
  faSortAlphaDown,
  faSortAlphaUp,
  faUserCog,
  faEdit,
  faTrash,
  faTrashAlt,
  faSearch,
  faPlus,
  faBan,
  faVolumeUp,
  faLink,
  faArrowUp,
  faArrowDown,
  faExchangeAlt,
  faCheck,
  faTimes,
  faEye,
  faEyeSlash,
  faSave,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'

library.add(
  faHome,
  faUsers,
  faCog,
  faSignOutAlt,
  faUser,
  faPhone,
  faPhoneSlash,
  faKey,
  faFileAlt,
  faPlay,
  faPause,
  faStop,
  faQuestion,
  faHandPointer,
  faPhoneAlt,
  faLightbulb,
  faRedoAlt,
  faDollarSign,
  faInfoCircle,
  faUserCircle,
  faSortAlphaDown,
  faSortAlphaUp,
  faUserCog,
  faEdit,
  faTrash,
  faTrashAlt,
  faSearch,
  faPlus,
  faBan,
  faVolumeUp,
  faLink,
  faArrowUp,
  faArrowDown,
  faExchangeAlt,
  faCheck,
  faTimes,
  faEye,
  faEyeSlash,
  faSave,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)

Vue.config.productionTip = false
Vue.use(configPlugin)

axios.interceptors.request.use(config => {
  const user = store.getters.user
  if (user && user.token) {
    config.headers.Authorization = `Bearer ${user.token}`
  }
  return config
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
